import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '@/services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.TicketDetailsResponse, (params: vp.TicketDetailsClientRequest) => void, () => void];

function useFetchTicketDetails({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.TicketDetailsClientRequest>();
  const [response, setResponse] = useState<vp.TicketDetailsResponse>({
    Success: false,
    ErrorMessage: '',
    Ticket: {
      dateAdded: '',
      lastUpdated: '',
      id: '',
      status: '',
      subject: '',
      description: '',
      author: '',
      ticketComments: [],
    },
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.TicketDetailsClientRequest) => {
      setDataFetchingInfo(true, 'loading ticket details', 'fullScreen');

      const res = await api.fetchTicketDetailsClient(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: vp.TicketDetailsClientRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Ticket: {
          dateAdded: '',
          lastUpdated: '',
          id: '',
          status: '',
          subject: '',
          description: '',
          author: '',
          ticketComments: [],
        },
      });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchTicketDetails);
